function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { QueryHelper } from '../../libs/query-helper';
import { mapState, mapGetters } from 'vuex';
export default {
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState(['searchFilters', 'userCountryCode'])), mapGetters(['hasSearchResults', 'getSearchFilter'])), {}, {
    /**
     * Map state as model
     */
    query: {
      get: function get() {
        return this.$store.state.searchFilters.query;
      },
      set: function set(value) {
        this.$store.commit('searchFilters', {
          property: 'query',
          value: value
        });
      }
    }
  }),
  methods: {
    /**
     * Search suppliers
     */
    performSearch: function performSearch() {
      if (!this.query) {
        this.query = QueryHelper.rand();
      }
      this.$store.dispatch('searchSuppliers');
    },
    /**
     * Bind to "Give me an idea" button
     */
    randomQuerySearch: function randomQuerySearch() {
      this.query = QueryHelper.rand();
      this.performSearch();
    },
    toggleFilterAndSearch: function toggleFilterAndSearch(property, value, resetValue) {
      var filterValue = this.getSearchFilter(property);
      if (Array.isArray(filterValue)) {
        this.toggleArrayFilter(filterValue, property, value, resetValue);
      } else {
        this.toggleFilter(filterValue, property, value, resetValue);
      }
      this.performSearch();
    },
    /**
     * Toggle filter value
     */
    toggleFilter: function toggleFilter(filterValue, property, value, resetValue) {
      if (filterValue == value) {
        this.$store.commit('searchFilters', {
          property: property,
          value: resetValue
        });
      } else {
        this.$store.commit('searchFilters', {
          property: property,
          value: value
        });
      }
    },
    /**
     * Toggle filter for properties with array value
     */
    toggleArrayFilter: function toggleArrayFilter(filterValue, property, value, resetValue) {
      if (filterValue.includes(value) && resetValue === '') {
        var i = filterValue.indexOf(value);
        filterValue.splice(i, i + 1);
      } else {
        filterValue.push(value);
      }
      this.$store.commit('searchFilters', {
        property: property,
        value: filterValue
      });
    }
  }
};